// extracted by mini-css-extract-plugin
export default {"links":"HelpSection_links__mj5Oj","phone":"HelpSection_phone__fY859"};